// Create a singleton mutable runtime configuration.
// This allows the host application to set configuration values at runtime in library mode.
const runtimeConfig = {
    API_DOMAIN: "",
    DC_API_DOMAIN: "",
    ROUTER_BASE_NAME: "",
    LIBRARY_MODE: Boolean(import.meta.env.VITE_LIBRARY_MODE)
};

// When used in library mode, the host application can specify the environment to set the API domain.
const API_DOMAIN_MAP: Record<string, string> = {
    dev: "https://delaget-dashboard-dev.delagetapp.com",
    test: "https://delaget-dashboard-test.delagetapp.com",
    stage: "https://delaget-dashboard-stage.delagetapp.com",
    prod: "https://dashboard.b50first.com"
};

/*
 * LIBRARY_MODE: Whether the app is running in library mode (i.e., being used as a component in another app)
 * API_DOMAIN: The base URL for the Delaget API server. This is "" by default (same-site) and should be set by the host application in library mode by specifying environment.
 * DC_API_DOMAIN: The base URL for the Data Central API. This is "" by default (unneeded when not in library mode) and should be set by the host application in library mode by specifying routerBasePath. This uses a relative URL since DC API is only going to be used when in library mode
 * ROUTER_BASE_NAME: The base name for the React Router. This is "" by default and should be set by the host application in library mode using routerBasePath and appBasePath.
 */
export const ENV = {
    get LIBRARY_MODE() {
        return runtimeConfig.LIBRARY_MODE;
    },
    get API_DOMAIN() {
        return runtimeConfig.API_DOMAIN;
    },
    get DC_API_DOMAIN() {
        return runtimeConfig.DC_API_DOMAIN;
    },
    get ROUTER_BASE_NAME() {
        return runtimeConfig.ROUTER_BASE_NAME;
    }
};

/**
 * Updates runtime configuration
 * Made into a separate function to ensure it is only called in library mode
 */
export function updateRuntimeConfig(
    environment?: string,
    routerBasePath?: string,
    appBasePath?: string
) {
    if (ENV.LIBRARY_MODE) {
        if (environment && API_DOMAIN_MAP[environment]) {
            runtimeConfig.API_DOMAIN = API_DOMAIN_MAP[environment];
        }
        if (routerBasePath) {
            runtimeConfig.DC_API_DOMAIN = routerBasePath;
        }
        if (appBasePath) {
            runtimeConfig.ROUTER_BASE_NAME =
                runtimeConfig.DC_API_DOMAIN + `/${appBasePath}`;
        }
    }
}

export function setLibraryMode(isLibraryMode: boolean) {
    runtimeConfig.LIBRARY_MODE = isLibraryMode;
}

// Prevent modifications to ENV structure
Object.freeze(ENV);
